import { useCallback, useMemo, useState } from 'react';
import { BIZ, comma, toNumber, won } from './data';

// 업종 선택 UI(#calculator 섹션)를 걷어내면서 기본 업종 기준으로 고정한다.
const DEFAULT_BIZ = BIZ[0];

/**
 * 히어로의 간이 견적 카드 상태.
 * 시안에서 renderVals() 가 매 렌더마다 계산하던 파생값을 그대로 옮겼다.
 */
export default function useEstimate() {
  const [sales, setSales] = useState(1000); // 월평균 온라인·카드매출 (만원)
  const [annual, setAnnual] = useState(30000); // 작년 매출액 (만원)
  const [expense, setExpense] = useState(12000); // 작년 매입·필요경비 (만원)

  const onNumber = useCallback((setter) => (e) => setter(toNumber(e.target.value)), []);

  return useMemo(() => {
    const limit = sales * DEFAULT_BIZ.mult;

    return {
      // 입력 표시값 + 핸들러
      salesVal: comma(sales),
      annualVal: comma(annual),
      expenseVal: comma(expense),
      onSales: onNumber(setSales),
      onAnnual: onNumber(setAnnual),
      onExpense: onNumber(setExpense),

      // 파생 결과
      limitLabel: won(limit),
      periodLabel: DEFAULT_BIZ.cycle,
      useMonthLabel: won(limit / 12),
    };
  }, [annual, expense, onNumber, sales]);
}
